const stores = {} // by se id

const init = (instance) => {
    if (stores[instance.id]) {
        return stores[instance.id]
    }

    stores[instance.id] = {
        request: {
            criteria: [],
            season: instance.options.season
        },
        resultsPerPage: '10',
        page: '0',
        sort: {
            type: null,
            direction: null
        },
        totalPages: null,
        totalProducts: null,
        products: [],
        counters: {
            criteria: []
        },
        lastResponseRaw: null,
        exclude: {
            criterias: [],
            fields: []
        },
        map: []
    }

    return stores[instance.id]
}

export default init
